import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Lock, User } from 'lucide-react';
import { mockCredentials } from '../mock';
import { toast } from '../hooks/use-toast';
import { Toaster } from './ui/toaster';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);

    setTimeout(() => {
      if (username === mockCredentials.username && password === mockCredentials.password) {
        toast({
          title: 'Inicio de sesión exitoso',
          description: 'Bienvenido al Banco Agrícola',
        });
        setTimeout(() => {
          navigate('/banking');
        }, 1000);
      } else {
        toast({
          title: 'Error de autenticación',
          description: 'Usuario o contraseña incorrectos',
          variant: 'destructive'
        });
        setLoading(false);
      }
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-600 via-green-700 to-green-800 flex items-center justify-center p-4">
      <Toaster />
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-1/2 -right-1/4 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-1/2 -left-1/4 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="w-full max-w-md relative z-10">
        <div className="text-center mb-8">
          <Link to="/">
            <div className="bg-white rounded-2xl p-4 inline-block mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_5732c38f-46bd-4a56-9931-c3cf86a70f4f/artifacts/nfkada7y_logo.jpg" 
                alt="Banco Agrícola" 
                className="h-20 w-auto"
              />
            </div>
          </Link>
          <h1 className="text-3xl font-bold text-white mb-2">Banca en Línea</h1>
          <p className="text-green-100">Accede a tu cuenta del Banco Agrícola</p>
          <p className="text-green-200 text-sm mt-2 font-medium">Sembrando Soberanía</p>
        </div>

        <Card className="border-0 shadow-2xl">
          <CardHeader>
            <CardTitle>Iniciar Sesión</CardTitle>
            <CardDescription>Ingresa tus credenciales para continuar</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleLogin} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="username">Usuario</Label>
                <div className="relative">
                  <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <Input 
                    id="username" 
                    type="text"
                    placeholder="Ingresa tu usuario"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="pl-10"
                    required
                  />
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Contraseña</Label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <Input 
                    id="password" 
                    type="password"
                    placeholder="Ingresa tu contraseña"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="pl-10"
                    required
                  />
                </div>
              </div>
              <Button 
                type="submit" 
                className="w-full bg-green-600 hover:bg-green-700"
                disabled={loading}
              >
                {loading ? 'Iniciando sesión...' : 'Ingresar'}
              </Button>
            </form>
            <div className="mt-6 text-center space-y-2">
              <a href="#" className="text-sm text-green-600 hover:underline block">¿Olvidaste tu contraseña?</a>
              <div className="pt-4 border-t">
                <p className="text-sm text-gray-600 mb-3">Credenciales de prueba:</p>
                <div className="bg-gray-50 p-3 rounded-lg text-sm space-y-1">
                  <p><span className="font-semibold">Usuario:</span> demo</p>
                  <p><span className="font-semibold">Contraseña:</span> demo123</p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="mt-6 text-center">
          <Link to="/" className="text-white hover:text-green-100 transition-colors">
            ← Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;